import * as React from "react";
import { MyAccountService } from "./myaccount-service";
import { Props } from "../../types/global";
import SupportTicketBlock from "./SupportTicketBlock";
import { Footer } from "./Footer";
import { Loading } from "../common/Loading";
import t from "../i18n";

declare type SupportTicketsState = {
    tickets?: any[];
}
export class SupportTickets extends React.Component<Props, SupportTicketsState> {
    readonly state: SupportTicketsState = {}
    componentDidMount() {
        MyAccountService.fetchTickets().then(result => {
            if (result) this.setState({ tickets: result.payLoad || [] });
            else this.props.history.replace("/topup");
        });
    }
    newTicket = () => {
        this.props.history.replace("/ticket/new");
    }
    renderNoTicket = () => {
        return <div className="container-fluid" style={pageWidth}>
            <div className="form-group form-title">
                <h2>{t.menu("support_tickets")}</h2>
            </div>
            <div>
                <div>{t.myaccount("no_ticket")}</div>
                <div dangerouslySetInnerHTML={{
                    __html: t.myaccount("no_ticket_message")
                }} />
            </div>
        </div>;
    }
    render() {
        if (!this.state.tickets) return <Loading />;
        if (this.state.tickets.length === 0) return this.renderNoTicket();
        return (
            <div className="container-fluid" style={pageWidth}>
                <div className="form-group form-title">
                    <h2>{t.menu("support_tickets")}</h2>
                </div>
                {this.state.tickets.map(ticket => <SupportTicketBlock key={ticket.id} ticket={ticket} />)}
                <Footer onButtonClick={this.newTicket} buttonText={t.myaccount("new_ticket")} />
            </div>
        );
    }
}
const pageWidth: React.CSSProperties = {
    maxWidth: 768,
    width: "100%",
}